export default __webpack_public_path__ + "static/media/icons8-reaccionar.db5e01fa.svg";